import { Length, ModelBase, NonNegative, Pattern, Property, ShortLength, VeryLongLength, VeryShortLength } from '@skylab-shared/core';
import { OrderDeliveryAddressModel } from './order-delivery-address.model';
import { OrderDeliveryDimensionModel } from './order-delivery-dimension.model';
import { OrderDeliveryShippmentMethodModel } from './order-delivery-shippment-method.model';
import { OrdersValidationPatterns } from './order-violation-patterns';

export class OrderDeliveryModel extends ModelBase {
	@Property()
	@Length({ max: VeryLongLength }, 'data-model.orders.delivery.validation.company-name.length')
	public companyName: string;

	@Property(OrderDeliveryAddressModel, {nullable: true})
	public address: OrderDeliveryAddressModel | null;

	@Property(OrderDeliveryDimensionModel, {nullable: true})
	public dimensions: OrderDeliveryDimensionModel | null;

	@Property(OrderDeliveryShippmentMethodModel, {nullable: true})
	public shipmentMethod: OrderDeliveryShippmentMethodModel | null;

	@Property()
	@Pattern({pattern: OrdersValidationPatterns.Name}, 'data-model.orders.delivery.validation.first-name.pattern')
	@Length({ max: ShortLength }, 'data-model.orders.delivery.validation.first-name.length')
	public firstName: string;

	@Property()
	@Pattern({pattern: OrdersValidationPatterns.Name}, 'data-model.orders.delivery.validation.last-name.pattern')
	@Length({ max: ShortLength }, 'data-model.orders.delivery.validation.last-name.length')
	public lastName: string;

	@Property()
	@Length({ max: VeryShortLength }, 'data-model.orders.delivery.validation.phone.length')
	@Pattern({pattern: OrdersValidationPatterns.Phone}, 'data-model.orders.delivery.validation.phone.pattern')
	public phone: string;

    @Property(Date, {nullable: true})
    public dispatchEnd: Date | null;

    @Property(Date, {nullable: true})
    public dispatchStart: Date | null; 

    @Property()
	@NonNegative('data-model.orders.delivery.validation.gross-cost.cannot-be-less-than-zero')
    public grossCost: number;

    @Property()
    public netCost: number;

	@Property()
	public parcelSize: string;

	@Property()
	@Length({ max: VeryLongLength }, 'data-model.orders.delivery.validation.pickup-point-name.length')
	public pickupPointName: string;

	@Property()
	public sendingParcelLocker: string;

    @Property()
    public taxExternalId: string;
}
